export default __webpack_public_path__ + "5651ae9405ff5af66d9f469ebbd19425.svg";